module.exports = __webpack_public_path__ + "img/RAR.b3ccb2b.svg";